import { createSlice } from '@reduxjs/toolkit';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import VwStkDurumDTO from 'src/models/StokEczane/StokDurum/VwStkDurumDTO';


interface IStokDurumState {
  isUrunSecEkleDialogOpen: boolean;
  stokDurumSearchResult?: VwStkDurumDTO[];
  stokDurumSelectedRow?: VwStkDurumDTO;
}

const StokDurumSlice = createSlice<
  IStokDurumState,
  MapReducerPayloads<
    IStokDurumState,
    {
      setIsUrunSecEkleDialogOpen: boolean;
      setStokDurumSearchResult: VwStkDurumDTO[];
      setStokDurumSelectedRow: VwStkDurumDTO;
    }
  >
>({
  name: 'StokDurum',
  initialState: {
    isUrunSecEkleDialogOpen: false,
    stokDurumSearchResult: null,
    stokDurumSelectedRow: null
  },
  reducers: {
    setIsUrunSecEkleDialogOpen: (state, action) => {
      state.isUrunSecEkleDialogOpen = action.payload;
    },
    setStokDurumSearchResult: (state, action) => {
      state.stokDurumSearchResult = action.payload;
    },
    setStokDurumSelectedRow: (state, action) => {
      state.stokDurumSelectedRow = action.payload;
    }
  }
});

export default StokDurumSlice;
